// MN-4816: Single source of truth for the customer-facing "Need artist edits?
// FREE" SLA disclosure shown on the DTF PDP (desktop) and the design-lab
// artist-edits modal (mobile / gold-standard).
//
// The actual turnaround number and delivery-promise impact are intentionally
// UNSET (null) until Ops confirms them with real data. Per the ticket
// discussion, disclosing a wrong SLA is worse than disclosing none, so this
// module never ships a fabricated figure — `turnaround` and `deliveryImpact`
// stay null until the confirmed P50 / delivery answer lands, at which point the
// values are filled in here (the one place) and the
// `artist_edits_sla_disclosure` Flip flag is turned on.
//
// Rendering is double-gated: the surface only mounts the disclosure when the
// Flip flag is enabled, and `artistEditsSlaLines` only emits a claim line for a
// field that has a confirmed value. An enabled flag with unconfirmed values
// therefore renders an empty (claim-free) placeholder, never an invented SLA.

export type ArtistEditsSla = {
  // Confirmed median turnaround, e.g. "2 hours". null = unconfirmed → no time
  // claim is rendered.
  turnaround: string | null;
  // Confirmed, customer-safe delivery-impact statement, e.g.
  // "Doesn't delay your delivery date". null = unconfirmed → no delivery claim
  // is rendered.
  deliveryImpact: string | null;
};

export const ARTIST_EDITS_SLA: ArtistEditsSla = {
  turnaround: null,
  deliveryImpact: null
};

// Pure: returns the disclosure lines to render, in order. Returns an empty array
// when nothing is confirmed yet, so callers render a claim-free placeholder
// rather than a fabricated SLA.
export function artistEditsSlaLines(sla: ArtistEditsSla = ARTIST_EDITS_SLA): string[] {
  const lines: string[] = [];
  if (sla.turnaround) {
    lines.push(`Usually done in ${sla.turnaround}`);
  }
  if (sla.deliveryImpact) {
    lines.push(sla.deliveryImpact);
  }
  return lines;
}
